// Import Constants
import C from "../constants";

// Import validation function
import { validateChangePassword } from "../../utils/changePasswordUtils";

const changePassword = (state = {}, action = {}) => {
  const { type = "", payload = {} } = action;
  const { key = "", value = "" } = payload;

  let newState = {};
  switch (type) {
    case C.UPDATE_CHANGED_PASSWORD:
      switch (key) {
        case "newPassword":
        case "confirmPassword":
        case "showChangePasswordError":
        case "oldPasswordResponseMessage":
          newState = {
            ...state,
            [key]: {
              ...state[key],
              value,
            },
          };
          break;
        case "oldPassword":
          newState = {
            ...state,
            [key]: {
              ...state[key],
              value,
            },
            oldPasswordResponseMessage: {
              message: "",
              value: "",
              status: "valid",
            },
          };
          break;
        default:
          console.error("UI ERROR");
          console.groupCollapsed("DETAILS");
          console.log("UNIDENTIFIED KEY in UPDATE_CHANGED_PASSWORD");
          console.log("REDUCER -> ", "changePassword reducer");
          console.log("state -> ", state);
          console.log("action -> ", action);
          console.groupEnd();
          newState = { ...state };
      }

      break;

    case C.SUBMIT_CHANGED_PASSWORD_INITIAL_ERROR:
      switch (key) {
        case "oldPassword":
        case "newPassword":
        case "confirmPassword":
        case "showChangePasswordError":
        case "oldPasswordResponseMessage":
          newState = {
            ...state,
            [key]: { ...value },
          };
          break;
        default:
          console.error("UI ERROR");
          console.groupCollapsed("DETAILS");
          console.log(
            "UNIDENTIFIED KEY in SUBMIT_CHANGED_PASSWORD_INITIAL_ERROR"
          );
          console.log("REDUCER -> ", "changePassword reducer");
          console.log("state -> ", state);
          console.log("action -> ", action);
          console.groupEnd();
          newState = { ...state };
      }

      break;
    default:
      console.error("UI ERROR");
      console.groupCollapsed("DETAILS");
      console.log("UNIDENTIFIED TYPE");
      console.log("REDUCER -> ", "changePassword reducer");
      console.log("state -> ", state);
      console.log("action -> ", action);
      console.groupEnd();
      newState = { ...state };
      break;
  }

  return validateChangePassword({ ...newState });
};

export default changePassword;
